import {getCurrentHub, Replay} from '@sentry/react';
import {useEffect} from 'react';

export const useStartReplay = () => {
  useEffect(() => {
    // This forces replay to record
    getCurrentHub().getClient()?.getIntegration(Replay)?.flush();
  }, []);
};
